export default {"src":"/_next/static/media/clock.00998b85.svg","height":18,"width":18,"blurWidth":0,"blurHeight":0};